module.exports = __webpack_public_path__ + "static/media/waveform-path.4ebfcac9.svg";